module.exports = __webpack_public_path__ + "img/interact-teacher-bg_new.cd40de55.png";